module.exports = __webpack_public_path__ + "assets/img/Edito_Franck-Bonin_menu.11dce3ae-ps.jpg";